var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [
              { name: "面接情報", pathName: "interviewInformationTop" },
            ],
            title: "面接情報_" + _vm.title + "確認",
          },
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-scout-send-container" },
          [
            _c("form-label", {
              attrs: {
                "class-name": "pega-form-label-importance",
                label: "登録名",
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { attrs: { "data-test": "name" } }, [
                        _vm._v(_vm._s(_vm.jobInterview.name)),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: {
                "class-name": "pega-form-label-importance",
                label: "求人設定",
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return _vm._l(_vm.selectedJobs, function (job, i) {
                      return _c("div", { key: "job-" + job.jobId }, [
                        _c("span", { attrs: { "data-test": "job-" + i } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(job.jobAdministrationName) +
                              "（ " +
                              _vm._s(job.jobName) +
                              " ）\n            "
                          ),
                        ]),
                      ])
                    })
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-2",
            attrs: { "data-test": "interview-information-title" },
          },
          [_vm._v("\n      概要\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-scout-send-container" },
          [
            _c("form-label", {
              attrs: { label: "書類選考の有無" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { attrs: { "data-test": "paper-screening" } }, [
                        _vm._v(_vm._s(_vm.paperScreeningLabel)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pega-pre-wrap",
                          attrs: { "data-test": "paper-screening-remarks" },
                        },
                        [_vm._v(_vm._s(_vm.jobInterview.paperScreeningRemarks))]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "適性検査の有無" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { attrs: { "data-test": "spi-test" } }, [
                        _vm._v(_vm._s(_vm.spiLabel)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pega-pre-wrap",
                          attrs: { "data-test": "spi-test-remarks" },
                        },
                        [_vm._v(_vm._s(_vm.jobInterview.spiTestRemarks))]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: {
                "class-name": "pega-pre-wrap",
                label: "応募する方への\nメッセージ",
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "pega-pre-wrap",
                          attrs: { "data-test": "message" },
                        },
                        [_vm._v(_vm._s(_vm.jobInterview.message))]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "boss-main-wrap boss-main-content-wrap pega-interview-detail-background margin-top-2 padding-bottom-3",
      },
      [
        _c(
          "div",
          {
            staticClass: "boss-joboffer-title boss-setting margin-top-1",
            attrs: { "data-test": "interview-detail-title" },
          },
          [_vm._v("\n      詳細\n    ")]
        ),
        _vm._v(" "),
        _c("div", [_vm._v("\n      応募者のみに表示されます。\n    ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-scout-send-container boss-bgcolor-white" },
          [
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-padding-x  pega-form pega-interview-form",
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell auto" },
                  [
                    _c("form-label", {
                      attrs: {
                        "class-name": "pega-form-label-interview",
                        label: "面接内容",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "pega-pre-wrap",
                                  attrs: { "data-test": "content" },
                                },
                                [_vm._v(_vm._s(_vm.jobInterview.content))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid-x grid-padding-x grid-padding-y pega-form pega-interview-form-top-none",
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "auto cell padding-top-0 padding-left-0 padding-right-0 interview-form-top-none",
                          },
                          _vm._l(
                            _vm.jobInterview.interviewers,
                            function (interviewer, i) {
                              return _c(
                                "div",
                                {
                                  key: "interviewer-" + interviewer.no,
                                  staticClass: "pega-interviewer-wrap",
                                },
                                [
                                  _c("div", { staticClass: "pega-mb-05" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "boss-bgcolor-white-gray pega-selection-label",
                                        attrs: {
                                          "data-test":
                                            "selection-no-label-" + i,
                                        },
                                      },
                                      [_vm._v(_vm._s(i + 1) + "次選考")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: {
                                        "data-test": "interviewer-label-" + i,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getInterviewLabel(interviewer)
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "pega-pre-wrap",
                                      attrs: {
                                        "data-test": "interviewer-remarks-" + i,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(interviewer.remarksOrFreeText)
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("form-label", {
                      attrs: { "class-name": "pega-form-label-interview" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("所要時間"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { attrs: { "data-test": "required-time" } },
                                [_vm._v(_vm._s(_vm.requiredTimeLabel))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "pega-pre-wrap",
                                  attrs: {
                                    "data-test": "required-time-remarks",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.jobInterview.requiredTimeRemarks)
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("form-label", {
                      attrs: {
                        "class-name": "pega-form-label-interview",
                        "form-class-name": "pega-interview-form-bottom-none",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("面接時の服装／持ち物"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("div", { attrs: { "data-test": "cloth" } }, [
                                _vm._v(_vm._s(_vm.clothLabel)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "pega-pre-wrap",
                                  attrs: { "data-test": "cloth-remarks" },
                                },
                                [_vm._v(_vm._s(_vm.jobInterview.clothRemarks))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-padding-x  pega-form pega-interview-form",
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell auto" },
                  [
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.businessManner,
                        label: "ビジネスマナー",
                        "read-only": true,
                        "form-label-class-name": "pega-form-label-interview",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.communicationAbility,
                        label: "コミュニケーション能力",
                        "read-only": true,
                        "form-label-class-name": "pega-form-label-interview",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.skill,
                        label: "過去の経験・スキル",
                        "read-only": true,
                        "form-label-class-name": "pega-form-label-interview",
                      },
                    }),
                    _vm._v(" "),
                    _c("form-item-rating", {
                      attrs: {
                        rating: _vm.jobInterview.motivation,
                        label: "やる気",
                        "read-only": true,
                        "form-label-class-name": "pega-form-label-interview",
                        "form-class-name": "pega-interview-form-bottom-none",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-padding-x  pega-form pega-interview-form",
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell auto" },
                  [
                    _c("form-label", {
                      attrs: { "class-name": "pega-form-label-interview" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [_c("span", [_vm._v("過去の質問例１")])]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "pega-pre-wrap",
                                  attrs: { "data-test": "question1" },
                                },
                                [_vm._v(_vm._s(_vm.jobInterview.question1))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("form-label", {
                      attrs: { "class-name": "pega-form-label-interview" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("過去の質問例２"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "pega-pre-wrap",
                                  attrs: { "data-test": "question2" },
                                },
                                [_vm._v(_vm._s(_vm.jobInterview.question2))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("form-label", {
                      attrs: { "class-name": "pega-form-label-interview" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("過去の質問例３"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "pega-pre-wrap",
                                  attrs: { "data-test": "question3" },
                                },
                                [_vm._v(_vm._s(_vm.jobInterview.question3))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("form-label", {
                      attrs: { "class-name": "pega-form-label-interview" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v("歓迎する質問"),
                                _c("small", [_vm._v("（任意）")]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return _vm._l(
                              _vm.welcomQuestionLabels,
                              function (question) {
                                return _c(
                                  "div",
                                  { key: "question-" + question.id },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-test": "welcome-quesetions",
                                        },
                                      },
                                      [_vm._v(_vm._s(question.name))]
                                    ),
                                  ]
                                )
                              }
                            )
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "boss-button-container" }, [
      _c(
        "button",
        {
          staticClass: "boss-button boss-button-return",
          attrs: { type: "button", "data-test": "button-back" },
          on: {
            click: function ($event) {
              return _vm.$emit("back")
            },
          },
        },
        [
          _c("span", { staticClass: "boss-button-return-text" }, [
            _vm._v("戻る"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "boss-button-center boss-button-confirm",
          attrs: { type: "button", "data-test": "button-submit" },
          on: {
            click: function ($event) {
              return _vm.$emit("submitted")
            },
          },
        },
        [
          _c("span", { staticClass: "boss-button-confirm-text" }, [
            _vm._v("この内容で登録する"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "text-center margin-top-1",
        attrs: { "data-test": "notification" },
      },
      [
        _c("div", [_vm._v("まだ完了しておりません。")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n        内容をご確認の上「登録する」ボタンを押してください。\n      "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "medium-3 cell  pega-pd-15  pega-interview-form-label" },
      [_c("span", [_vm._v("面接の選考情報")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "medium-3 cell pega-form-label pega-form-label-interview-top",
        attrs: { "data-test": "form-label" },
      },
      [_c("span", [_vm._v("面接官について")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "medium-3 cell  pega-pd-15  pega-interview-form-label" },
      [
        _c("span", [
          _vm._v("重視するポイント"),
          _c("br"),
          _vm._v(" "),
          _c("small", [_vm._v("「★」が多いほど重視するポイントとなります。")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "medium-3 cell  pega-pd-15  pega-interview-form-label pega-interview-form-label-bottom",
      },
      [_c("span", [_vm._v("中途面接について")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }